import React, { Component } from "react";
import { Typography, Collapse } from "@material-ui/core";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import SelectAuto from "../../components/selects/select-auto";
import { ESFERICO, CILINDRICO } from "../../web-ordering/order/3_order_perscription/order-perscription-lists";
import "./../lente-pronta.css";

class LenteProntaEtapaTres extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.handleToggler = this.handleToggler.bind(this);
  }

  handleToggler(event, newValue) {
    if (newValue !== null) {
      this.props.onChange({
        prescricaoOlhos: newValue,
        prescricao_OD: { esferico: "", cilindrico: "" },
        prescricao_OE: { esferico: "", cilindrico: "" },
        produtoResolvido: false,
      });
    }
  }

  handleChangeOD = (field, value) => {
    if (value && this.props.clearHighlight) {
      this.props.clearHighlight(field + "_OD");
    }
    this.props.onChange(
      {
        prescricao_OD: {
          ...this.props.prescricao_OD,
          [field]: value ? value.value : "",
        },
      },
      () => {
        if (this.props.onPrescricaoChange) {
          this.props.onPrescricaoChange();
        }
      },
    );
  };

  handleChangeOE = (field, value) => {
    if (value && this.props.clearHighlight) {
      this.props.clearHighlight(field + "_OE");
    }
    this.props.onChange(
      {
        prescricao_OE: {
          ...this.props.prescricao_OE,
          [field]: value ? value.value : "",
        },
      },
      () => {
        if (this.props.onPrescricaoChange) {
          this.props.onPrescricaoChange();
        }
      },
    );
  };

  toSelectValue(val) {
    return val ? { value: val, label: val } : null;
  }

  render() {
    const { prescricaoOlhos, prescricao_OD, prescricao_OE, disableFields, resolvendoProduto, buscandoVoucher, dominiosDioptria } = this.props;
    const showOD = prescricaoOlhos === "ambos" || prescricaoOlhos === "direito";
    const showOE = prescricaoOlhos === "ambos" || prescricaoOlhos === "esquerdo";
    const esfericoOptions = dominiosDioptria?.esferico?.length > 0 ? dominiosDioptria.esferico : ESFERICO;
    const cilindricoOptions = dominiosDioptria?.cilindrico?.length > 0 ? dominiosDioptria.cilindrico : CILINDRICO;
    const disableSelects = disableFields || resolvendoProduto || buscandoVoucher;

    return (
      <div>
        <div className="row mb-4">
          <div className="col-12">
            <ToggleButtonGroup
              value={prescricaoOlhos}
              exclusive
              onChange={this.handleToggler}
              aria-label="seleção de olhos"
            >
              <ToggleButton value="ambos" id="lp_prescricao_ambos" disabled={disableFields} disableRipple aria-label="ambos os olhos">
                Ambos os olhos
              </ToggleButton>
              <ToggleButton value="direito" id="lp_prescricao_direito" disabled={disableFields} disableRipple aria-label="olho direito">
                Olho direito
              </ToggleButton>
              <ToggleButton value="esquerdo" id="lp_prescricao_esquerdo" disabled={disableFields} disableRipple aria-label="olho esquerdo">
                Olho esquerdo
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
        </div>

        <Collapse in={showOD} timeout={300}>
          <div className="row mb-3">
            <div className="col-12">
              <Typography variant="subtitle1" style={{ color: "#00518b" }} gutterBottom>Olho direito</Typography>
            </div>
            <div className="col-12 col-md-6">
              <SelectAuto
                id="esferico_OD"
                name="esferico_OD"
                label="Esférico*"
                aria="Selecione o esférico do olho direito"
                width="100%"
                options={esfericoOptions}
                placeholder="Selecione o esférico"
                onlyDot
                onChange={value => this.handleChangeOD("esferico", value)}
                value={this.toSelectValue(prescricao_OD.esferico)}
                disabled={disableSelects}
              />
            </div>
            <div className="col-12 col-md-6">
              <SelectAuto
                id="cilindrico_OD"
                name="cilindrico_OD"
                label="Cilíndrico*"
                aria="Selecione o cilíndrico do olho direito"
                width="100%"
                options={cilindricoOptions}
                placeholder="Selecione o cilíndrico"
                onlyDot
                onChange={value => this.handleChangeOD("cilindrico", value)}
                value={this.toSelectValue(prescricao_OD.cilindrico)}
                disabled={disableSelects}
              />
            </div>
          </div>
        </Collapse>

        <Collapse in={showOE} timeout={300}>
          <div className="row mb-3">
            <div className="col-12">
              <Typography variant="subtitle1" style={{ color: "#00518b" }} gutterBottom>Olho esquerdo</Typography>
            </div>
            <div className="col-12 col-md-6">
              <SelectAuto
                id="esferico_OE"
                name="esferico_OE"
                label="Esférico*"
                aria="Selecione o esférico do olho esquerdo"
                width="100%"
                options={esfericoOptions}
                placeholder="Selecione o esférico"
                onlyDot
                onChange={value => this.handleChangeOE("esferico", value)}
                value={this.toSelectValue(prescricao_OE.esferico)}
                disabled={disableSelects}
              />
            </div>
            <div className="col-12 col-md-6">
              <SelectAuto
                id="cilindrico_OE"
                name="cilindrico_OE"
                label="Cilíndrico*"
                aria="Selecione o cilíndrico do olho esquerdo"
                width="100%"
                options={cilindricoOptions}
                placeholder="Selecione o cilíndrico"
                onlyDot
                onChange={value => this.handleChangeOE("cilindrico", value)}
                value={this.toSelectValue(prescricao_OE.cilindrico)}
                disabled={disableSelects}
              />
            </div>
          </div>
        </Collapse>
      </div>
    );
  }
}

export default LenteProntaEtapaTres;
